import {Stack} from '@mantine/core';
import {FC} from 'react';
import {DefaultValues, SubmitHandler} from 'react-hook-form';
import {z} from 'zod';
import {ActionClassService} from '../api/generated/ActionClassService';
import {ActionCodesService} from '../api/generated/ActionCodesService';
import {CodesService} from '../api/generated/CodesService';
import {createForm} from '../forms';
import {AdditionalParams} from '../hooks/paged-data-table/types';
import {useOptions} from '../hooks/use-options';
import {mapNullToUndefined} from '../utils/zod';

type FilterState = AdditionalParams<typeof ActionClassService.getAll>;
export type ComponentState = {
  filter: FilterState;
  tableState?: Parameters<typeof ActionClassService.getAll>[0];
};

const filterSchema = z.object({
  actionCodeId: mapNullToUndefined(z.number().optional()),
  levelOfServiceCodeId: mapNullToUndefined(z.number().optional()),
  class: mapNullToUndefined(z.string().optional()),
}) satisfies z.Schema<FilterState>;
export type FilterSchema = z.TypeOf<typeof filterSchema>;

const Form = createForm<FilterSchema>();

type TableFiltersProps = {
  defaultValues?: DefaultValues<FilterSchema>;
  onSubmit: SubmitHandler<FilterSchema>;
};

export const TableFilters: FC<TableFiltersProps> = ({
  defaultValues,
  onSubmit,
}) => {
  const actionCodeOptions =
    useOptions(ActionCodesService.getActionCodeOptions).value ?? [];
  const levelOfServiceCodeOptions =
    useOptions(CodesService.getLevelOfServiceCodeOptions).value ?? [];
  const partClassOptions =
    useOptions(ActionClassService.getPartClassOptions).value ?? [];

  return (
    <Form
      onSubmit={onSubmit}
      schema={filterSchema}
      defaultValues={defaultValues}
    >
      <Stack>
        <Form.Select
          clearable
          searchable
          name='actionCodeId'
          label='Action Code'
          data={actionCodeOptions}
          placeholder='Select Action Code'
        />
        <Form.Select
          clearable
          searchable
          name='levelOfServiceCodeId'
          label='Level of Service'
          data={levelOfServiceCodeOptions}
          placeholder='Select Level of Service'
        />
        <Form.Select
          clearable
          searchable
          name='class'
          label='Part Class'
          placeholder='Select Part Class'
          data={partClassOptions}
        />
        <Form.Submit>Apply</Form.Submit>
      </Stack>
    </Form>
  );
};
